export default "__VITE_ASSET__c5a14eff__"